/// <amd-module name="SuiteCommerce.Blog.Post"/>
define("SuiteCommerce.Blog.Post", ["require", "exports", "SuiteCommerce.Blog.Post.View", "Utils"], function (require, exports, Post_View_1, Utils) {
    "use strict";
    return {
        mountToApp: function (container) {
            var pageTypeComponent = container.getComponent('PageType');
            this.registerPageTypes(pageTypeComponent);
        },
        registerPageTypes: function (pageTypeComponent) {
            pageTypeComponent.registerPageType({
                name: 'ext-blog-post',
                view: Post_View_1.PostView,
                defaultTemplate: {
                    name: 'sc_blog_post_default_layout.tpl',
                    displayName: 'Blog Post',
                    thumbnail: Utils.getAbsoluteUrl(getExtensionAssetsPath('img/ic_cct_sc_blog_post.svg')),
                },
            });
        },
    };
});
